import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Col,
  Form,
  Row,
  Tooltip,
  Popconfirm,
  Spin,
  Popover,
  Dropdown,
  Menu,
  Checkbox,
  message,
  Button,
} from "antd";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import ExelDownload from "../../../image/exeldownload.svg";
import RefreshIcon from "../../../image/refreshIcon.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import RfqFloat from "../../../image/RfqFloat.svg";
import NegotiationStage from "../../../image/NegotiationStage.svg";
import OfferStage from "../../../image/OfferStage.svg";
import TotalCount from "../../../image/TotalCount.svg";
import cancelicon from "../../../image/cancelicon.svg";
import {
  ClockCircleOutlined,
  DownloadOutlined,
  EyeOutlined,
  FilterOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import BidIconss from "../../../image/BidIconss.svg";
import Reasign from "../../../image/Reasign.svg";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import { authUserData } from "../../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import { debounce } from "lodash";
import VendorDotStatus from "../../vendor/VendorDotStatus";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { ReactComponent as ColumnList } from "../../../image/ColumnList.svg";
import sweep from "../../../image/sweep.png";

const VendorGeneralRFQHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const formRef = useRef();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistoryVendor, setVendorRFQHistory] = useState([]);
  const [reload, setReload] = useState(false);
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [selectCompany, setSelectCompany] = useState([]);
  const [selectParticularCompany, setSelectParticularCompany] = useState([]);
  const [unassignedpr, setUnassignedpr] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // Tracks click processing
  const [isLocked, setIsLocked] = useState(false); // Global lock to prevent actions
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const vendorUserId = authUserData()?.vendor ? authUserData()?.user_id : null;
  const vendorUserName = authUserData()?.vendor
    ? authUserData()?.first_name
    : null;
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);
  const [pendingBid, setPendingBid] = useState(false);
  const [selectedPrNumber, setSelectedPrNumber] = useState(null);
  const [dotLoaded, setDotLoaded] = useState(false);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filterDate, setFilterDate] = useState([
    "2D",
    "3D",
    "5D",
    "7D",
    "1M",
    "All",
  ]);
  const [selectedFilter, setSelectedFilter] = useState("5D");
  const VendorID = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
  });
  const [statusCounts, setStatusCounts] = useState({
    purchase_order_received: 0,
    total_rfq: 0,
    initial_offer_to_be_submitted: 0,
    revised_offer_to_be_submitted: 0,
    total_recevied_rfq: 0,
    approval_stage_count: 0,
    draft_pr_count: 0,
    negotiation_stage_count: 0,
    offer_stage_count: 0,
    order_placed_count: 0,
    rfq_cancelled_count: 0,
    rfq_floated_count: 0,
    rfq_hold_count: 0,
    rfq_yet_to_be_floated_count: 0,
    rfq_rejected_count: 0,
    revised_stage_count: 0,
  });
  const navigate = useNavigate();
  const debouncedHandleClick = useCallback(
    debounce(async (action, params, onClose) => {
      setLoading(true);
      if (isLocked || isProcessing || loading) {
        return;
      }
      setIsLocked(true);
      setIsProcessing(true);
      try {
        await action(...params);
        onClose();
      } catch (error) {
        console.error("Error in action:", error);
        message.error("Failed to process RFQ");
      } finally {
        message.destroy();
        setLoading(false);
        setIsProcessing(false);
        setIsLocked(false);
      }
    }, 500),
    [isLocked, isProcessing, loading]
  );

  const handleAssignToBuyerChange = async (value, record) => {
    if (value === "me") {
      const hasBeenAssigned = record.rfq_assign_sales_manager[0].id !== null;
      confirmAlert({
        customUI: ({ onClose }) => (
          <>
            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0, 0, 0, 0.5)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin size="large" tip="Processing RFQ..." />
              </div>
            )}
            <div
              className="custom-ui"
              style={{
                padding: "30px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                opacity: loading ? 0.7 : 1,
              }}
            >
              <h1
                style={{
                  color: "#094e8f",
                  fontSize: "22px",
                  fontWeight: "bold",
                  fontFamily: "none",
                  padding: "0px 0px 20px",
                }}
              >
                Confirm
              </h1>
              <p style={{ marginBottom: "20px" }}>
                {hasBeenAssigned
                  ? "Are you sure you want to Reassign to me for BID RFQ ?"
                  : "Are you sure you want to Assign to me for BID RFQ ?"}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#094e8f",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading || isProcessing || isLocked ? "not-allowed" : "pointer",
                    opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                  }}
                  disabled={loading || isProcessing || isLocked}
                  onClick={() => {
                      saveAssignToBuyer(
                            hasBeenAssigned,
                            vendorUserId,
                            record.id,
                            record.rfq_assign_sales_manager[0]?.id
                          );
                      onClose()
                  }}
                >
                  Yes
                </button>
                <button
                  style={{
                    backgroundColor: "#F1F1F1",
                    color: "#000",
                    padding: "10px 20px",
                    fontSize: "16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading || isProcessing || isLocked ? "not-allowed" : "pointer",
                    opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                  }}
                  disabled={loading || isProcessing || isLocked}
                  onClick={() => {
                    onClose();
                  }}
                >
                  No
                </button>
                {record.category_tree_name === "Cement" ||
                record.category_tree_name.includes("Sand") || record.category_tree_name.includes("Aggregate") || record.category_tree_name.includes("Earthing") ? (
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="button"
                    label="Assign & BID"
                    loading={loading}
                    disabled={loading || isProcessing || isLocked}
                    style={{
                      minWidth: "120px",
                      padding: "10px 20px",
                      fontSize: "16px",
                      opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                    }}
                    onClick={() => {

                          setLoading(true);
                          saveAssignToBuyer(
                            hasBeenAssigned,
                            vendorUserId,
                            record.id,
                            record.rfq_assign_sales_manager[0]?.id
                          );
                          navigate(
                            `/rfq-vendor-request-for-quotation-city-wise/bid-rfq/${btoa(
                              record.id
                            )}`
                          );
                          setLoading(false);
                
                        onClose()
                    }}
                  />
                ) : (
                  <button
                    style={{
                      backgroundColor: "#094e8f",
                      color: "#fff",
                      padding: "10px 20px",
                      fontSize: "16px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: loading || isProcessing || isLocked ? "not-allowed" : "pointer",
                      opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                    }}
                    disabled={loading || isProcessing || isLocked}
                    onClick={() => {
                          setLoading(true)
                           saveAssignToBuyer(
                            hasBeenAssigned,
                            vendorUserId,
                            record.id,
                            record.rfq_assign_sales_manager[0]?.id
                          );
                          navigate(
                            `/rfq-vendor-request-for-quotation-city-wise/bid-rfq-steel/${btoa(
                              record.id
                            )}`
                          );
                          setLoading(false);
                      
                        onClose()
                    }}
                  >
                    Assign & BID
                  </button>
                )}
              </div>
            </div>
          </>
        ),
      });
    } else {
      const selectedEmployee = assignBuyer.find(
        (employee) => employee.id === value
      );
      const employeeName = selectedEmployee ? selectedEmployee.first_name : "";
      const hasBeenAssigned = record.rfq_assign_sales_manager[0].id !== null;
      confirmAlert({
        customUI: ({ onClose }) => (
          <>
            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0, 0, 0, 0.5)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin size="large" tip="Processing RFQ..." />
              </div>
            )}
            <div
              className="custom-ui"
              style={{
                padding: "30px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                opacity: loading ? 0.7 : 1,
              }}
            >
              <h1
                style={{
                  color: "#094e8f",
                  fontSize: "22px",
                  fontWeight: "bold",
                  fontFamily: "none",
                  padding: "0px 0px 20px",
                }}
              >
                Confirm
              </h1>
              <p style={{ marginBottom: "20px" }}>
                {hasBeenAssigned
                  ? `Are you sure you want to Reassign ${employeeName} for BID RFQ ?`
                  : `Are you sure you want to Assign ${employeeName} for BID RFQ ?`}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#094e8f",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading || isProcessing || isLocked ? "not-allowed" : "pointer",
                    opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                  }}
                  disabled={loading || isProcessing || isLocked}
                  onClick={() => {
                    debouncedHandleClick(
                      saveAssignToBuyer,
                      [
                        hasBeenAssigned,
                        value,
                        record.id,
                        record.rfq_assign_sales_manager[0].id,
                      ],
                      onClose
                    );
                  }}
                >
                  Yes
                </button>
                <button
                  style={{
                    backgroundColor: "#F1F1F1",
                    color: "#000",
                    padding: "10px 20px",
                    fontSize: "16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading || isProcessing || isLocked ? "not-allowed" : "pointer",
                    opacity: loading || isProcessing || isLocked ? 0.6 : 1,
                  }}
                  disabled={loading || isProcessing || isLocked}
                  onClick={() => {
                    onClose();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </>
        ),
      });
    }
  };

  const saveAssignToBuyer = async (
    hasBeenAssigned,
    value,
    RecordId,
    prevId
  ) => {
    let payload;
    if (hasBeenAssigned) {
      payload = {
        id: prevId,
        rfq_assign_sales_manager: value,
      };
    } else {
      payload = {
        rfq_assign_sales_manager: value,
      };
    }
    try {
      setLoading(true);
      const [response] = await Promise.all([
        patchRequest(
          `float-rfq/${RecordId}/vendor-assign-to-sales-manager/`,
          payload
        ),
        new Promise((resolve) => {
          setTimeout(resolve, 500)
          setLoading(false);
        }), 
      ]);
      setLoading(false);
      const successMessage =
        response.data.message || "Assignment updated successfully";
      SuccessNotificationMsg(successMessage);
      setReload(!reload);
      setLoading(false);
    } catch (error) {
      console.error("Error updating assignee:", error);
      setLoading(false);
      ErrorNotificationMsg("Failed to update assignee");
      throw error;
    }
  };

  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };

  const handleReset = () => {
    setSelectedCard(null);
    setUnassignedpr([]);
    setSelectCompany([]);
    setEndDate("");
    setStartDate("");
    setSelectParticularCompany("");
    setSelectedFilter("All");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
    });
    formRef.current.setFieldsValue({
      rfq_created_date__gte: null,
      rfq_assign_sales_manager: null,
      category: [],
      rfq_created_date__lte: null,
      company_name: null,
    });
  };

  const handleClickCard = (status) => {
    setSelectedCard(status);
    setEndDate("");
    setStartDate("");

    formRef.current.setFieldsValue({
      rfq_created_date__gte: null,
      rfq_assign_sales_manager: null,
      category: [],
      rfq_created_date__lte: null,
      company_name: null,
    });
    const startDate = formatDate(getPastDate(dayMapping["All"]));
    const endDate = formatDate(new Date());

    if (Array.isArray(status) && status.length > 0) {
      setState((prevState) => ({
        ...prevState,
        stage: status.join(", "), 
        rfq_created_date__gte: "", 
        rfq_created_date__lte: "",
        search: "",
        page: 1,
        pagesize: 10,
        rfq_status: "",
      }));
    } else if (status === "Purchase Order Rejected By Vendor") {
      setState((prevState) => ({
        ...prevState,
        stage: status || "", 
        rfq_created_date__gte: "", 
        rfq_created_date__lte: "", 
        search: "",
        page: 1,
        pagesize: 10,
        rfq_status: "",
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        stage: "",
        rfq_status: status || "", 
        rfq_created_date__gte: "",
        rfq_created_date__lte: "", 
        search: "",
        page: 1,
        pagesize: 10,
      }));
    }
  };

  const handleHover = (prNumber) => {
    if (selectedPrNumber !== prNumber) {
      setSelectedPrNumber(prNumber);
    }
    setDotLoaded(false);
  };

  const handleRefresh = async () => {
    setSelectedCard(null);
    setEndDate("");
    setStartDate("");
    formRef.current.setFieldsValue({
      rfq_created_date__gte: null,
      rfq_assign_sales_manager: null,
      category: [],
      rfq_created_date__lte: null,
      company_name: null,
    });
    setState((prevState) => {
      const {
        rfq_created_date__gte,
        rfq_created_date__lte,
        rfq_status,
        search,
        ...rest
      } = prevState;
      return {
        ...rest,
        page: 1,
        pagesize: 10,
        ordering: "id",
        rfq_created_date__gte: "",
        rfq_created_date__lte: "",
      };
    });
  };

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleExcelDownload = async () => {
    const endpoint = `float-rfq/${VendorId}/rfq-excel-download-vendor/`;
    const fileType = "csv";

    try {
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `float-rfq_${VendorId}-${+new Date()}.${fileType}`;
          link.click();
        })
        .catch((error) => {
          ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  useEffect(() => {
    const initializeFilters = () => {
      const startDate = formatDate(getPastDate(dayMapping["5D"]));
      const endDate = formatDate(new Date());

      setState((prevState) => ({
        ...prevState,
        rfq_created_date__gte: startDate,
        rfq_created_date__lte: endDate,
      }));
      setSelectedFilter("5D");
    };

    initializeFilters();
  }, []);

  const getVendorRFQHistory = async () => {
    try {
      setApiLoading(true);
      let apiResponse = await getRequest(
        `float-rfq/list-vendor-rfq/?rfq_approval_status=Approve&&vendor_id=${VendorId}&company_id=${selectParticularCompany}`,
        state
      );

      if (apiResponse.data.results.data) {
        const RFQData = apiResponse.data.results.data.map((item) => item.id);
        setVendorRFQHistory(RFQData);
        setVendorRFQHistory(apiResponse.data.results.data);
        setRFQHistory(apiResponse.data.results.data);
        setPendingBid(apiResponse.data.results.data.final_bid_data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history"));
      }
    } catch (error) {
      console.error("Error fetching RFQ history:", error);
    } finally {
      setApiLoading(false);
    }
  };

  useEffect(() => {
    if (
      (state.rfq_created_date__gte !== undefined &&
        state.rfq_created_date__lte !== undefined) ||
      state.search
    ) {
      getVendorRFQHistory();
    }
  }, [state, reload]);

  useEffect(() => {
    getStatusCount();
    getSelectCompany();
  }, []);

  const getPastDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const shortYear = year % 100;
    return `${day}-${month}-${shortYear}`;
  };

  const dayMapping = {
    "2D": 1,
    "3D": 2,
    "5D": 4,
    "7D": 6,
    "1M": 29,
    All: 730,
  };

  const applyFilter = (item) => {
    if (dayMapping[item] !== undefined) {
      const startDate = formatDate(getPastDate(dayMapping[item]));
      const endDate = formatDate(new Date());

      const filterParams = {
        rfq_created_date__gte: startDate,
        rfq_created_date__lte: endDate,
        rfq_assign_sales_manager: unassignedpr,
      };

      setState(filterParams);
      setSelectedFilter(item);
    }
  };

  const getStatusCount = async () => {
    try {
      let apiResponse = await getRequest(
        `float-rfq/vendor-rfq-category-count?vendor=${VendorId}`
      );
      if (apiResponse.data.success) {
        const message = apiResponse.data.data;
        setStatusCounts({
          total_recevied_rfq: message.total_recevied_rfq,
          approval_stage_count: message.approval_stage_count,
          draft_pr_count: message.draft_pr_count,
          negotiation_stage_count: message.negotiation_stage_count,
          offer_stage_count: message.offer_stage_count,
          order_placed_count: message.order_placed_count,
          rfq_cancelled_count: message.rfq_cancelled_count,
          rfq_floated_count: message.rfq_floated_count,
          rfq_hold_count: message.rfq_hold_count,
          rfq_yet_to_be_floated_count: message.rfq_yet_to_be_floated_count,
          purchase_order_received: message.purchase_order_received,
          initial_offer_to_be_submitted: message.initial_offer_to_be_submitted,
          revised_offer_to_be_submitted: message.revised_offer_to_be_submitted,
          total_rfq: message.total_rfq,
          rfq_rejected_count: message.rfq_rejected_count,
          revised_stage_count: message.revised_stage_count,
        });
      } else {
        ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
    }
  };

  const getSelectCompany = async (data) => {
    await getRequest("float-rfq/get-company-by-vendor/", data)
      .then((response) => {
        setSelectCompany(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching company data:", error);
      });
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "rfq_status" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_status";
    }
    if (sortField === "rfq_status" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_status";
    }
    if (sortField === "rfq_approval_by_name" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_approval_by_name";
    }
    if (sortField === "rfq_approval_by_name" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_approval_by_name";
    }
    if (sortField === "rfq_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_approval_date";
    }
    if (sortField === "rfq_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_approval_date";
    }
    if (sortField === "rfq_due_date" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_due_date";
    }
    if (sortField === "rfq_due_date" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_due_date";
    }
    if (sortField === "rfq_total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_total_amount";
    }
    if (sortField === "rfq_total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_total_amount";
    }
    return sortingEnumKey;
  };

  const handleApplyFilter = () => {
    setSelectedCard(null);
    const filterParams = {
      rfq_created_date__gte: startDate,
      rfq_created_date__lte: endDate,
      rfq_assign_sales_manager: unassignedpr,
    };
    setState(filterParams);
  };

  useEffect(() => {
    const getAssignBuyer = async () => {
      try {
        const response = await getRequest(`float-rfq/sales-manager-by-vendor/`);
        setAssignBuyer(response.data.results.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getAssignBuyer();
  }, []);

  const isDueDateActive = (dueDateStr) => {
    if (!dueDateStr) return false;
    try {
      const [datePart, timePart] = dueDateStr.split(" ");
      const [yy, mm, dd] = datePart.split("-").map(Number);
      const [hh, min] = timePart.split(":").map(Number);
      const fullYear = 2000 + yy;
      const dueDate = new Date(fullYear, mm - 1, dd, hh, min);
      return dueDate.getTime() > new Date().getTime();
    } catch {
      return false;
    }
  };

  const handlePdfDownload = async () => {
    try {
      const pdf = new jsPDF("p", "pt", "a4");
      const pdfColumns = [
        "Client Name",
        "Buyer Name",
        "RFQ Number",
        "City",
        "RFQ Due Date",
      ];
      let rows = [];
      rfqHistory.forEach((item) => {
        const cityNames =
          item.total_quantity_by_site && item.total_quantity_by_site.length > 0
            ? item.total_quantity_by_site
                .map((site) => site.site_wise_city_name)
                .join(", ")
            : "";
        const row = [
          item.company_name,
          item.rfq_approval_by_name,
          item.rfq_number,
          cityNames,
          item.rfq_details[0]?.rfq_due_date || "",
        ];
        rows.push(row);
      });
      pdf.text("RFQ History", 235, 40);
      pdf.autoTable({
        head: [pdfColumns],
        body: rows,
        startY: 65,
        theme: "grid",
        styles: {
          font: "times",
          halign: "center",
          overflow: "linebreak",
          cellPadding: 3.5,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [255, 255, 255],
          fontStyle: "normal",
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fillColor: [9, 78, 143],
        },
        alternateRowStyles: {
          fillColor: [212, 212, 212],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        rowStyles: {
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        tableLineColor: [0, 0, 0],
      });
      pdf.save(`float-rfq_${+new Date()}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const isExpiringSoon = (dueDateStr) => {
    if (!dueDateStr) return false;
    const [datePart, timePart] = dueDateStr.split(" ");
    const [dd, mm, yy] = datePart.split("-").map(Number);
    const [hh, min] = timePart.split(":").map(Number);
    const fullYear = 2000 + yy;
    const dueDate = new Date(fullYear, mm - 1, dd, hh, min);
    return dueDate > new Date();
  };

  const handleDownload = async (prNumber, categoryTreeName) => {
    try {
      const endpoint = `bid-rfq/${prNumber}/get-bid-rfq-city-wise/?vendor_id=${VendorID}`;
      const response = await getRequest(endpoint);
      if (response.data) {
        const rfqNumber = response.data.data.rfq_number || "N/A";
        const companyName = response.data.data.company || "N/A";
        const currency = response.data.data.currency_name || "N/A";
        const priceBasis = response.data.data.price_basis || "N/A";
        const freight = response.data.data.freight || "N/A";
        const unLoading = response.data.data.unloading || "N/A";
        const transportInsurance =
          response.data.data.transport_insurance || "N/A";
        const rfqDueDate = response.data.data.rfq_due_date || "N/A";
        const deliveryDate = response.data.data.delivery_date || "N/A";
        const pdf = new jsPDF("p", "pt", "a4");
        const xMargin = 40;
        let yCursor = 40;
        pdf.setFont("times", "bold");
        pdf.setFontSize(12);
        const detailsColumns = [
          "RFQ Number",
          "Company Name",
          "Currency",
          "Price Basis",
          "Freight",
          "Unloading",
          "Transport Insurance",
          "RFQ Due Date",
          "Delivery Date",
        ];
        const detailsRows = [
          [
            rfqNumber,
            companyName,
            currency,
            priceBasis,
            freight,
            unLoading,
            transportInsurance,
            rfqDueDate,
            deliveryDate,
          ],
        ];
        pdf.autoTable(detailsColumns, detailsRows, {
          startY: yCursor,
          theme: "grid",
          styles: {
            font: "times",
            halign: "center",
            cellPadding: 3.5,
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
          },
          headStyles: {
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            fillColor: [255, 255, 255],
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
          },
          rowStyles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
          },
          tableLineColor: [0, 0, 0],
        });
        yCursor = pdf.lastAutoTable.finalY + 20;
        const pdfColumns = categoryTreeName === "Earthing" ? [
          "SR No.",
          "City",
          "Site",
          "Item",
          "Qty",
          "UoM",
        ] : [
          "SR No.",
          "City",
          "Site",
          "Item",
          "Qty",
          "UoM",
          "Qty in KG",
        ];
        const pdfRows = [];
        let srNo = 1;
        let cityCounter = 1;
        let isFirstCityRow = true;
        response?.data?.data?.bid_rfq_city_wise_detail.forEach((cityData) => {
          const cityName = cityData.city_name;
          const cityIndex = cityCounter++;
          let isFirstCityRow = true;
          cityData.bid_rfq_site_details.forEach((siteData) => {
            const siteName = siteData.site_name;
            let isFirstMaterial = true;
            siteData.bid_rfq_material_details.forEach((materialData) => {
              const materialTypeName = materialData.material_type_name || "N/A";
              const quantity = materialData.material_total_quantity || "N/A";
              const quantityInKg =
                materialData.material_total_quantity_by_kg || "N/A";
              const uom = materialData.material_wise_uom || "N/A";
              if (isFirstMaterial) {
                pdfRows.push([
                  isFirstCityRow ? cityIndex : "",
                  isFirstCityRow ? cityName : "",
                  siteName,
                  materialTypeName,
                  quantity,
                  uom,
                  quantityInKg,
                ]);
                isFirstMaterial = false;
                isFirstCityRow = false;
              } else {
                pdfRows.push([
                  "",
                  "",
                  "",
                  materialTypeName,
                  quantity,
                  uom,
                  quantityInKg,
                ]);
              }
            });
            if (siteData.bid_rfq_material_details.length === 0) {
              pdfRows.push([
                isFirstCityRow ? cityIndex : "",
                isFirstCityRow ? cityName : "",
                siteName,
                "No Material",
                "N/A",
                "N/A",
                "N/A",
              ]);
              isFirstCityRow = false;
            }
          });
        });
        pdf.autoTable(pdfColumns, pdfRows, {
          startY: yCursor,
          theme: "grid",
          styles: {
            font: "times",
            halign: "center",
            cellPadding: 3.5,
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
          },
          headStyles: {
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            fillColor: [255, 255, 255],
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
          },
          rowStyles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
          },
          tableLineColor: [0, 0, 0],
        });
        pdf.save(
          `purchase_requisition_summary_${VendorID}_${prNumber}_${+new Date()}`
        );
      }
    } catch (error) {
      console.error("Error generating download:", error);
    }
  };

  const columns = [
    {
      title: "Client Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      width: 100,
      sorter: true,
    },
    {
      title: "Buyer Name",
      dataIndex: "rfq_approval_by_name",
      key: "rfq_approval_by_name",
      width: 100,
      sorter: true,
    },
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      width: 100,
      sorter: true,
    },
    {
      title: "City",
      dataIndex: "city_names",
      key: "city_names",
      width: 120,
      sorter: true,
      render: (city_names) => {
        if (city_names && city_names.length > 0) {
          const cityNames = city_names.map((item) => item).join(", ");
          return (
            <Tooltip color="#094E8F" title={cityNames} placement="left">
              <span>{cityNames}</span>
            </Tooltip>
          );
        } else {
          return "";
        }
      },
    },
    {
      title: "RFQ Due Date",
      dataIndex: "rfq_due_date",
      key: "rfq_due_date",
      sorter: true,
      render: (text, record) => {
        const rfqDetails = record.rfq_details[0];
        return rfqDetails.rfq_due_date;
      },
    },
    {
      title: "Assign RFQ",
      sorter: true,
      dataIndex: "rfq_assign_sales_manager",
      key: "rfq_assign_sales_manager",
      render: (e, record) => {
        const exists = e.find(
          (item) => item.rfq_assign_sales_manager_name === vendorUserName
        );
        const me = exists ? "me" : e[0]?.rfq_assign_sales_manager_name;
        const dueDateStr = record.rfq_details?.[0]?.rfq_due_date;
        let dueDate = null;
        if (dueDateStr) {
          const [datePart, timePart] = dueDateStr.split(" ");
          const [dd, mm, yy] = datePart.split("-").map(Number);
          const [hh, min] = timePart.split(":").map(Number);
          const fullYear = 2000 + yy;
          dueDate = new Date(fullYear, mm - 1, dd, hh, min);
        }
        const now = new Date();
        const isDueDateTimePassed = dueDate && dueDate < now;
        const isAlreadyBidAndAssigned =
          record.bid_rfq_by_vendor === true &&
          record.rfq_assign_sales_manager?.[0]?.id !== null;
        const shouldDisable = isDueDateTimePassed || isAlreadyBidAndAssigned;
        return (
          <div>
            <Select
              value={me}
              placeholder="Select"
              defaultValue={e[0]?.rfq_assign_sales_manager_name}
              style={{ width: 120 }}
              onChange={(e) => handleAssignToBuyerChange(e, record)}
              disabled={shouldDisable}
            >
              <Select.Option key="01" value="me">
                Assign to me
              </Select.Option>
              {assignBuyer.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  {option.first_name}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "RFQ Status",
      dataIndex: "bid_rfq_stage",
      key: "bid_rfq_stage",
      width: 210,
      sorter: true,
      render: (text) => {
        if (text === "Initial (R0) Bid to be Submitted") {
          return (
            <Tooltip color="#094E8F" title={"Initial (R0) Bid Submitted"} placement="left">
              Initial (R0) Bid Submitted
            </Tooltip>
          );
        } else if (text === "Revised (R1) Bid to be Submitted") {
          return (
            <Tooltip color="#094E8F" title={"Revised (R1) Bid Submitted"} placement="left">
              Revised (R1) Bid Submitted
            </Tooltip>
          );
        } else if (text === "Revised (Final) Bid to be Submitted") {
          return (
            <Tooltip color="#094E8F" title={"Revised (Final) Bid Submitted"} placement="left">
              Revised (Final) Bid Submitted
            </Tooltip>
          );
        } else {
          return (
            <Tooltip color="#094E8F" title={text || "RFQ Received"} placement="left">
              {text ? text : "RFQ Received"}
            </Tooltip>
          );
        }
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 180,
      render: (e, record, rfq_status) => {
        const rfqAssignSalesManager = record.rfq_assign_sales_manager;
        const exists = rfqAssignSalesManager.find(
          (item) => item.rfq_assign_sales_manager_name === vendorUserName
        );
        const me = exists
          ? "me"
          : rfqAssignSalesManager[0]?.rfq_assign_sales_manager_name;
        const menu = (
          <Menu>
            <Menu.Item
              key="1"
              onClick={() => handleAssignToBuyerChange("me", record)}
            >
              Assign to me
            </Menu.Item>
            {assignBuyer.map((option) => (
              <Menu.Item
                key={option.id}
                onClick={() => handleAssignToBuyerChange(option.id, record)}
              >
                {option.first_name}
              </Menu.Item>
            ))}
          </Menu>
        );
        let tooltipTitle = "RFQ Received";
        const stage = record.bid_rfq_stage?.trim();
        if (stage === "RFQ Received") {
          tooltipTitle = "Submit Initial (R0) Bid";
        } else if (stage === "Initial (R0) Bid to be Submitted") {
          tooltipTitle = "Submit Revised (R1) Bid";
        } else if (stage === "Revised (R1) Bid to be Submitted") {
          tooltipTitle = "Submit Final (R) Bid";
        } else if (stage === "Revised (Final) Bid Submitted") {
          tooltipTitle = "Submit Revised (Final) Bid";
        }
        return (
          <Space>
            <Popover
              placement="left"
              content={
                <VendorDotStatus
                  prNumber={selectedPrNumber}
                  VendorID={VendorID}
                  prID={record.id}
                  setDotLoaded={setDotLoaded}
                  record={record}
                />
              }
              title={`Status Of RFQ Number: ${selectedPrNumber}`}
              onVisibleChange={(visible) => {
                if (!visible) {
                  setSelectedPrNumber(null);
                }
              }}
            >
              <ClockCircleOutlined
                onMouseEnter={() => handleHover(record.rfq_number)}
                style={{ cursor: "pointer" }}
              />
            </Popover>
            <Tooltip title="View RFQ">
              {record.category_tree_name === "Cement" || record.category_tree_name.includes("Sand") || record.category_tree_name.includes("Aggregate") || record.category_tree_name.includes("Earthing") ? (
                <Link
                  to={
                    "/rfq-vendor-request-for-quotation/new-view-bid-rfq/" +
                    btoa(record.id)
                  }
                >
                  <EyeOutlined />
                </Link>
              ) : (
                <Link
                  to={
                    "/rfq-vendor-request-for-quotation/new-view-bid-rfq-steel/" +
                    btoa(record.id)
                  }
                >
                  <EyeOutlined />
                </Link>
              )}
            </Tooltip>
            {isExpiringSoon(record.rfq_details[0].rfq_due_date) && (
              <>
                {record?.rfq_assign_sales_manager[0]
                  .rfq_assign_sales_manager_name &&
                  record.is_show_bid && (
                    <Tooltip
                      title={tooltipTitle}
                      color={"#094E8F"}
                      placement="left"
                    >
                      {record.category_tree_name === "Cement" || record.category_tree_name.includes("Sand") || record.category_tree_name.includes("Aggregate") || record.category_tree_name.includes("Earthing") ? (
                        <Link
                          to={{
                            pathname:
                              "/rfq-vendor-request-for-quotation-city-wise/bid-rfq/" +
                              btoa(record.id),
                          }}
                        >
                          <img src={BidIconss} alt="" />
                        </Link>
                      ) : (
                        <Link
                          to={{
                            pathname:
                              "/rfq-vendor-request-for-quotation-city-wise/bid-rfq-steel/" +
                              btoa(record.id),
                          }}
                        >
                          <img src={BidIconss} alt="" />
                        </Link>
                      )}
                    </Tooltip>
                  )}
              </>
            )}
            {record.final_bid_data === false &&
              record.is_final_bid_price === false &&
              record?.rfq_assign_sales_manager[0]
                .rfq_assign_sales_manager_name !== null &&
              record.purchase_order === false &&
              isExpiringSoon(record.rfq_details[0]?.rfq_due_date) && (
                <Tooltip title="Reassign RFQ">
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <img
                      src={Reasign}
                      alt="Reassign Icon"
                      style={{ cursor: "pointer" }}
                    />
                  </Dropdown>
                </Tooltip>
              )}
            <Tooltip title="Download BID RFQ">
              <DownloadOutlined onClick={() => handleDownload(record.id, record.category_tree_name)} />
            </Tooltip>
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
              placement="leftTop"
            >
              <Tooltip title="Archive RFQ">
                <Archive style={{ cursor: "pointer" }} />
              </Tooltip>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const handleCompanySelectChange = (value) => {
    setSelectParticularCompany(value);
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    if (value) {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          rfq_status,
          ...rest
        } = prevState;
        return {
          ...rest,
          search: value,
        };
      });
    } else {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          search,
          ...rest
        } = prevState;
        return {
          ...rest,
        };
      });
    }
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const [checkedList, setCheckedList] = useState([
    "operation",
    "company_name",
    "category_tree_name",
    "rfq_approval_by_name",
    "rfq_number",
    "site_wise_city_name",
    "rfq_due_date",
    "rfq_assign_sales_manager",
    "bid_rfq_stage",
    "city_names",
  ]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter((column) =>
    checkedList.includes(column.key)
  );

  const columnMenu = (
    <Menu
      className="packagelistdropdown"
      style={{ width: "450px", padding: "10px", borderRadius: "8px" }}
    >
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Row style={{ width: "100%" }}>
            {columns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox value={column.key} disabled={column.key === "operation"}>
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> RFQ History - Vendor</h3>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            <Link
              to={`/rfq-vendor-request-for-quotation/history/archive/${id}`}
            >
              <Archiveicon />
            </Link>
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <section className="Block-Sec-Demo1 mb-5">
            <Row gutter={[15]} className="rfqCard">
              {[
                {
                  status: "",
                  title: "Total RFQ",
                  count: statusCounts.total_rfq,
                  icon: TotalCount,
                  clickHandler: () => handleClickCard(""),
                },
                {
                  status: "RFQ Floated",
                  title: "Initial Offer to be submitted",
                  count: statusCounts.initial_offer_to_be_submitted,
                  icon: OfferStage,
                  clickHandler: () => handleClickCard("RFQ Floated"),
                },
                {
                  status: [
                    "Initial (R0) Bid to be Submitted",
                    "Revised (R1) Bid to be Submitted",
                  ],
                  title: "Revised Offer to be submitted (R1) & (R)",
                  count: statusCounts.revised_offer_to_be_submitted,
                  icon: RfqFloat,
                  clickHandler: () =>
                    handleClickCard([
                      "Initial (R0) Bid to be Submitted",
                      "Revised (R1) Bid to be Submitted",
                    ]),
                },
                {
                  status: [
                    "Purchase Order Accepted By Client",
                    "Purchase Order Accepted By Vendor",
                  ],
                  title: "Purchase Order Received",
                  count: statusCounts.purchase_order_received,
                  icon: NegotiationStage,
                  clickHandler: () =>
                    handleClickCard([
                      "Purchase Order Accepted By Client",
                      "Purchase Order Accepted By Vendor",
                    ]),
                },
                {
                  status: "Purchase Order Rejected By Vendor",
                  title: "RFQ Lost",
                  count: statusCounts.rfq_rejected_count,
                  icon: cancelicon,
                  clickHandler: () =>
                    handleClickCard("Purchase Order Rejected By Vendor"),
                },
              ].map((item, index) => {
                const isActive = Array.isArray(item.status)
                  ? Array.isArray(selectedCard)
                    ? item.status.some((status) =>
                        selectedCard.includes(status)
                      )
                    : item.status.includes(selectedCard)
                  : selectedCard === item.status;
                return (
                  <Col key={index}>
                    <div
                      className={`card mb-5 ${isActive ? "active" : ""}`}
                      onClick={() => {
                        item.clickHandler();
                      }}
                      style={{
                        width: "fit-content",
                        maxWidth: "100%",
                      }}
                    >
                      <div className={`card-block block-${index + 1}`}>
                        <div className="card-box">
                          <div className="card-icon">
                            <img
                              src={item.icon}
                              alt={item.title}
                              width={35}
                            />
                          </div>
                          <div className="card-description">
                            <h3 className="color-blue">{item.title}</h3>
                            <p>{item.count}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__gte">
                      <DatePicker
                        format="DD-MM-YYYY"
                        placeholder="Select Start Date"
                        allowClear={false}
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__lte">
                      <DatePicker
                        format="DD-MM-YYYY"
                        placeholder="Select End Date"
                        allowClear={false}
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="company_name">
                      <Select
                        showArrow
                        showSearch
                        allowClear
                        placeholder="Select Company"
                        optionFilterProp="children"
                        onChange={(value) => handleCompanySelectChange(value)}
                        style={{ width: "150px" }}
                      >
                        {selectCompany &&
                          selectCompany.length > 0 &&
                          selectCompany.map((item) => (
                            <Select.Option
                              key={item.company_id}
                              value={item.company_id}
                            >
                              {item.company_name}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={handleApplyFilter}
                    />
                    <Button
                      type="primary"
                      htmlType="Reset"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={handleReset}
                    />
                  </>
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                <Col xs={24}>
                  <div
                    style={{
                      color: "#094E8F",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Tooltip
                      color="#094E8F"
                      title={"RFQ filter by number of days / month"}
                    >
                      <strong>Last:</strong>
                    </Tooltip>
                    <span className="rfq-number new1">
                      {filterDate.map((item, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor:
                              selectedFilter === item && "white",
                            margin: "0 5px",
                            padding: "8px 18px",
                            cursor: "pointer",
                            fontWeight:
                              selectedFilter === item ? "bold" : "normal",
                            color:
                              selectedFilter === item ? "black" : "black",
                            border:
                              selectedFilter === item
                                ? "0.5px solid rgb(154, 165, 177)"
                                : "none",
                            boxShadow:
                              selectedFilter === item
                                ? "-1px 1px 5px 2px rgba(56,135,201,0.75)"
                                : "none",
                            transition: "box-shadow 0.3s ease-in-out",
                          }}
                          onClick={() => {
                            setSelectedFilter(item);
                            applyFilter(item);
                            setSelectedCard(null);
                          }}
                        >
                          {item}
                        </span>
                      ))}
                    </span>
                  
                  </div>
                  
                  </Col>
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Refresh"
                    label="Refresh"
                    onClick={handleRefresh}
                    icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                  />
                  <div>
                    <Space
                      style={{
                        backgroundColor: "#094e8f",
                        padding: "4px",
                        borderRadius: "4px",
                      }}
                    >
                      <Dropdown
                        overlay={columnMenu}
                        trigger={["hover"]}
                        placement="bottomRight"
                        visible={dropdownVisible}
                        onVisibleChange={setDropdownVisible}
                      >
                        <Tooltip
                          title="Modify Columns"
                          placement="topLeft"
                          color="#094E8F"
                        >
                          <Button
                            className="SaveGradiantBtn"
                            type="primary"
                            icon={<ColumnList />}
                            style={{ minWidth: "36px" }}
                          />
                        </Tooltip>
                      </Dropdown>
                    </Space>
                  </div>
                </Space>
                {selectedRow.length > 0 && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={t("pl_Archive")}
                    />
                  </Popconfirm>
                )}
              </div>
            </div>
            <div className="tablewrp">
              <Table
                className="wrptbl"
                rowSelection={rowSelection}
                columns={filteredColumns}
                apiLoading={apiLoading}
                dataSource={rfqHistoryVendor}
                scroll={{
                  x: "auto",
                }}
                loading={apiLoading}
                onChange={handleTableChange}
                rowKey={(record) => record.id}
                pagination={{
                  current: state.page,
                  pageSize: state.pagesize,
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showSizeChanger: true,
                  showTotal: (totalCount) => `Total ${totalCount} items`,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                }}
              />
            </div>
          </div>
        </section>
      </>
    );
  };

export default VendorGeneralRFQHistory;